import PropTypes from 'prop-types';

const propType = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  companyName: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  address: PropTypes.string,
  address_1: PropTypes.string,
  address_2: PropTypes.string,
  zipCode: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  countryCode: PropTypes.string,
  provinceCode: PropTypes.string,
  provinceCountryCode: PropTypes.string,
};

const defaultProp = {
  firstName: '',
  lastName: '',
  companyName: '',
  phone: '',
  email: '',
  address: '',
  address_1: '',
  address_2: '',
  zipCode: '',
  city: '',
  state: '',
  country: '',
  countryCode: '',
  provinceCode: '',
  provinceCountryCode: '',
};

export default { propType, defaultProp };
